<template>
	<div class="rounded-6 mb-3 border bold-shadow p-3">
		<div class="row no-gutters">
			<div class="col-8 align-self-center">
				<div class="pr-3">
					<p class="mb-0 body-2-1">{{data.name}}</p>
					<p 
						v-if="is_decrease_promo" 
						class="mb-0 text-line-through body-3 d-inline-block align-middle mr-1">
						{{$formatCurrency(promotion_price)}}
					</p>
					<p 
						class="mb-0 body-2-4 text-orange mr-1"
						:class="{
							'd-inline-block align-middle': is_decrease_promo
						}"
						>
						{{$formatCurrency(final_price)}}
					</p>
					<span
						v-if="is_decrease_promo" 
						class="mb-0 font-bold text-green bg-green-light px-1 rounded-4 d-inline-block align-middle text-12">-{{Math.floor(data.price.promotion_pct)}}%</span>

				</div>
			</div>
			<div class="col-4 align-self-center">
				<button
					v-if="qty_cart == 0"
					@click="changeQty('plus')" 
					class="ga-btn-primary-outline w-100">
					Select
				</button>
				<div class="plus-min-set w-100 text-right" v-else>
          <img src="../../../../assets/img/icon/minus-black.png" class="d-inline-block img-crement border border-dark rounded-100" width="28" @click="changeQty('minus')">
          <p class="d-inline-block border-none text-center body-2-4 counter mb-0" style="width:35px;">{{qty_cart}}</p>
          <img src="../../../../assets/img/icon/plus-black.png" class="d-inline-block border border-dark img-crement rounded-100"
            width="28" @click="changeQty('plus')">
        </div>
			</div>
		</div>
	</div>
</template>
<script>
	import {mapGetters} from 'vuex'
	import {calculateFinalPriceConcierge} from '@/utils/index.js'

	export default{
		props: ['data','product_cart_index'],
		data(){
			return{
				qty_cart: 0
			}
		},
		computed:{
			...mapGetters(['getConciergeOrder']),
			variant_in_cart(){
				let return_data = -1
				if(this.product_cart_index != -1){
					return_data = this.getConciergeOrder.cart[this.product_cart_index].variant.findIndex(x=>x.data.product_ga_pos_id == this.data.product_ga_pos_id)
				}
				return return_data
			},
			final_price(){
        return calculateFinalPriceConcierge(this.data.price)
      },
      promotion_price(){
        if(this.data.price.promotion_amount == 0){
          return 0
        }else{
          return this.data.price.tax_service_calculation_type == 'INCLUDE' ? this.data.price.price_sell_base : this.data.price.price_sell
        }
      },
      is_decrease_promo(){
        if(this.data.price.promotion_amount == 0){
          return false
        }else{
          return this.data.price.promotion_type == 'INCREASE' ? false : true
        }
      },
		},
		watch:{
			qty_cart(){
				this.$emit('updateQty',{
					data: this.data,
					qty: this.qty_cart 
				})
			}
		},
		mounted(){
			if(this.variant_in_cart != -1) {
				this.qty_cart = this.getConciergeOrder.cart[this.product_cart_index].variant[this.variant_in_cart].qty
			}
		},
		methods:{
			changeQty(type){
				if(type == 'plus'){
					this.qty_cart++
				}else{
					if(this.qty_cart > 0){
						this.qty_cart--
					}
				}
			}
		}
	}
</script>
<style scoped>
	.img-crement {
    padding: 7px;
    border-radius: 5px;
  }
	@media screen and (max-width: 600px) {
    .plus-min-set {
      margin-left: -20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hotel/concierge/general/MenuVariantFoodSquare.vue